export const selectSiteData = (state) =>
  state.data.sitesetting?.siteSetting?.[0]?.data;

